import { useEffect, useState } from "react";

const query = "(hover: none) and (pointer: coarse), (max-width: 767px)";

// True on phones/tablets: used to drop GPU-heavy blur filters and shorten motion.
export function useIsMobile() {
  const [mobile, setMobile] = useState(() => (typeof window !== "undefined" ? window.matchMedia(query).matches : false));
  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = (e) => setMobile(e.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);
  return mobile;
}
